export const zh = {
  "Rubrics": "评分量规",
  "New Rubric": "新建量规",
  "Create scoring rubrics for any topic, subject, or assignment": "为任何主题、科目或作业创建评分量规",
  "AI Draft": "AI草稿",
  "Start Blank": "从空白开始",
  "Topic / what to assess": "主题 / 评估内容",
  "Class (optional)": "班级（可选）",
  "Title (optional)": "标题（可选）",
  "Levels": "等级",
  "Generate Rubric": "生成量规",
  "Create": "创建",
  "Criteria": "评分标准",
  "Criterion name": "标准名称",
  "Descriptor...": "描述...",
  "Add Criterion": "添加标准",
  "Add level": "添加等级",
  "Remove level": "删除等级",
  "Remove": "删除",
  "Score Student": "给学生评分",
  "Save to Gradebook": "保存到成绩册",
  "Tap cells below to score": "点击下方单元格评分",
  "Select student": "选择学生",
  "Select a rubric or create a new one": "选择一个量规或创建新的",
  "No rubrics yet. Create your first one!": "还没有量规。创建第一个吧！",
  "Rubric created!": "量规已创建！",
  "Rubric saved": "量规已保存",
  "Rubric deleted": "量规已删除",
  "Rubric duplicated": "量规已复制",
  "Delete this rubric?": "删除此量规？",
  "Duplicate": "复制",
  "No class": "无班级",
  "Rubric": "量规",
  "Saved to gradebook": "已保存到成绩册",
  "Failed to save score": "保存评分失败",
  "Select a class and student": "请选择班级和学生",
  "Failed to create rubric. Please try again.": "创建失败，请重试。",
  "Analyzing the topic...": "正在分析主题...",
  "Defining criteria...": "正在定义标准...",
  "Writing level descriptors...": "正在撰写等级描述...",
  "Excellent": "优秀",
  "Good": "良好",
  "Fair": "及格",
  "Needs Improvement": "需要改进",
  "New Level": "新等级",
  "Total points possible": "总分",
  "Loading...": "加载中...",
  "Failed to duplicate": "复制失败",
  "Send to Google Classroom": "发送到 Google Classroom",
  "Opening Google Classroom...": "正在打开 Google Classroom...",
  "Failed to share to Classroom": "分享到 Classroom 失败",
  "Analyzing standards...": "正在分析课程标准...",
  "Writing content...": "正在撰写内容...",
  "Formatting sections...": "正在排版...",
  "Finalizing...": "即将完成...",
  "All Plans": "全部教案",
  "Color": "颜色",
  "Current": "当前",
  "Delete": "删除",
  "Delete this folder? Plans will be moved to \"Unfiled\"": "删除此文件夹？教案将移至\"未分类\"",
  "Edit": "编辑",
  "Edit Folder": "编辑文件夹",
  "Error creating folder": "创建文件夹出错",
  "Error deleting folder": "删除文件夹出错",
  "Error moving plan": "移动教案出错",
  "Error updating folder": "更新文件夹出错",
  "Ex: Math 5th Grade": "例：五年级数学",
  "Folder created": "文件夹已创建",
  "Folder deleted": "文件夹已删除",
  "Folder name": "文件夹名称",
  "Folder updated": "文件夹已更新",
  "Folders": "文件夹",
  "Move to folder": "移动到文件夹",
  "New Folder": "新建文件夹",
  "No objective defined": "未定义目标",
  "No unfiled plans": "没有未分类的教案",
  "Plan moved": "教案已移动",
  "This folder is empty": "此文件夹为空",
  "Unfiled": "未分类",
  "You don't have any lesson plans": "您还没有教案",
  "Your lesson plans": "您的教案",
  "Take Attendance": "点名考勤",
  "You have": "您有",
  "class(es) without attendance today": "个班级今天尚未考勤",
  "Student Intervention Needed": "需要关注学生",
  "student(s) showing significant struggles - consider reaching out": "名学生表现出明显困难 - 建议主动联系",
  "Overdue Grading": "批改逾期",
  "assignment(s) past due date need grading": "项已过期作业待批改",
  "Plan Next Week": "规划下周课程",
  "class(es) don't have lessons planned for next week": "个班级下周尚无课程计划",
  "10th Grade": "十年级",
  "11th Grade": "十一年级",
  "12th Grade": "十二年级",
  "1st Grade": "一年级",
  "2nd Grade": "二年级",
  "3rd Grade": "三年级",
  "4th Grade": "四年级",
  "5th Grade": "五年级",
  "6th Grade": "六年级",
  "7th Grade": "七年级",
  "8th Grade": "八年级",
  "9th Grade": "九年级",
  "AI Assignment generated": "AI作业已生成",
  "AI Assignments": "AI作业",
  "AI Assistant": "AI助手",
  "AI Generated": "AI生成",
  "AI Grading": "AI批改",
  "AI Recommendations": "AI建议",
  "AI Suggestions": "AI建议",
  "AI Teaching Assistant": "AI教学助手",
  "Access Link": "访问链接",
  "Access resources to help plan your lessons": "获取资源以帮助您备课",
  "Activity Ideas": "活动创意",
  "Adapt": "调整",
  "Adapt with AI": "用AI调整",
  "Adaptive Learning": "自适应学习",
  "Add": "添加",
  "Add New Category": "添加新类别",
  "Add Question": "添加题目",
  "Add option": "添加选项",
  "Add pair": "添加配对",
  "Add to Calendar": "添加到日历",
  "Additional Instructions (optional)": "附加说明（可选）",
  "Additional Notes": "附加备注",
  "Additional instructions": "附加说明",
  "Additional notes...": "附加备注...",
  "All caught up!": "全部完成！",
  "All semesters": "所有学期",
  "All students on track!": "所有学生进度正常！",
  "All suggestions applied": "已应用所有建议",
  "Analysis took too long. Please try again.": "分析时间过长，请重试。",
  "Analyzing PDF with AI... This may take up to a minute.": "正在用AI分析PDF……最多可能需要一分钟。",
  "Analyzing...": "正在分析...",
  "Answer Key": "答案",
  "Answer:": "答案：",
  "Apply All": "全部应用",
  "Apply as-is": "按原样应用",
  "Apply to notes": "应用到备注",
  "Approve & Publish": "批准并发布",
  "Art": "美术",
  "Ask me about planning, standards, teaching strategies...": "向我咨询备课、课程标准、教学策略等问题...",
  "Assessment": "测评",
  "Assignment List": "作业列表",
  "Assignment created": "作业已创建",
  "Assignment created!": "作业已创建！",
  "Assignment created. Student link copied to clipboard.": "作业已创建。学生链接已复制到剪贴板。",
  "Assignment deleted": "作业已删除",
  "Assignment name": "作业名称",
  "Assignment updated": "作业已更新",
  "Assignments & Gradebook": "作业与成绩册",
  "Assignments to Grade": "待批改作业",
  "At Risk": "需关注",
  "Attendance": "考勤",
  "Attendance Rpt": "考勤报告",
  "Attendance saved": "考勤已保存",
  "Automate your entire Sunday night prep with a single prompt": "一条指令即可自动完成整个周日晚上的备课",
  "Back": "返回",
  "Based on grades & attendance": "基于成绩和考勤",
  "Bilingual": "双语",
  "Both (CC + PR)": "两者（CC + PR）",
  "Briefly describe what makes this lesson structure successful...": "简要描述这个课程结构成功的原因...",
  "Build Questions": "创建题目",
  "CC + PR": "CC + PR",
  "Calendar": "日历",
  "Calendar Events": "日历事件",
  "Cancel": "取消",
  "Cannot delete category with assignments": "无法删除包含作业的类别",
  "Categories": "类别",
  "Category": "类别",
  "Category created": "类别已创建",
  "Category deleted": "类别已删除",
  "Category updated": "类别已更新",
  "Chat": "聊天",
  "Chat with AI Assistant": "与AI助手聊天",
  "Choose File": "选择文件",
  "Class": "班级",
  "Class created": "班级已创建",
  "Class deleted": "班级已删除",
  "Class updated": "班级已更新",
  "Classes Today": "今日课程",
  "Close": "关闭",
  "Closure": "总结",
  "Column A": "A列",
  "Column B": "B列",
  "Complete required fields": "请填写必填项",
  "Connecting to server... Retrying": "正在连接服务器……重试中",
  "Content generated! Use the Save button to save it.": "内容已生成！请使用保存按钮保存。",
  "Convert to Online Test": "转换为在线测试",
  "Copied!": "已复制！",
  "Copy": "复制",
  "Copy Link": "复制链接",
  "Copy link": "复制链接",
  "Copy student link": "复制学生链接",
  "Core": "核心课程",
  "Correct answer": "正确答案",
  "Create assessments with answers": "创建带答案的测评",
  "Create with AI": "用AI创建",
  "Created with TeacherHubPro - AI Assistant for Teachers": "由 TeacherHubPro 创建 - 教师AI助手",
  "Creative classroom activities": "创意课堂活动",
  "Current Categories": "当前类别",
  "Customized template applied!": "自定义模板已应用！",
  "Dark": "深色",
  "Dark mode": "深色模式",
  "Date Range (2 Weeks)": "日期范围（2周）",
  "Date of Test/Quiz": "测试/测验日期",
  "Day theme...": "当日主题...",
  "Delete this assignment?": "删除此作业？",
  "Delete this prep batch?": "删除此备课批次？",
  "Delete this template?": "删除此模板？",
  "Deleted": "已删除",
  "Describe the learning goal...": "描述学习目标...",
  "Describe what you need to prep and the agent will generate everything automatically": "描述您需要准备的内容，智能体将自动生成所有材料",
  "Describe your lesson and AI will generate a standards-based plan.": "描述您的课程，AI将生成基于课程标准的教案。",
  "Description": "描述",
  "Description / Instructions": "描述/说明",
  "Differentiation strategies": "差异化教学策略",
  "Difficulty": "难度",
  "Done": "完成",
  "Due Date (optional)": "截止日期（可选）",
  "Due:": "截止：",
  "Duration (minutes)": "时长（分钟）",
  "E.g., Decimal multiplication": "例如：小数乘法",
  "E.g., Equivalent fractions": "例如：等值分数",
  "E.g., Focus on word problems...": "例如：侧重应用题...",
  "E.g., Fractions Plan - 4th Grade": "例如：分数教案 - 四年级",
  "E.g., Fractions with different denominators": "例如：异分母分数",
  "E.g., Fractions, American Revolution...": "例如：分数、美国独立战争...",
  "E.g., math, fractions, hands-on": "例如：数学、分数、动手实践",
  "ELA": "语文",
  "Easy": "简单",
  "Edit Assignment": "编辑作业",
  "Edit Class": "编辑班级",
  "Edit Parent Email": "编辑家长邮件",
  "Edit class": "编辑班级",
  "Educational Games": "教育游戏",
  "End": "结束",
  "English": "英语",
  "English/Reading": "英语/阅读",
  "Enjoy your day off": "祝您休息日愉快",
  "Enrichment": "拓展",
  "Enter a topic": "输入主题",
  "Enter question...": "输入题目...",
  "Enter your prep request": "输入您的备课需求",
  "Error applying template": "应用模板出错",
  "Error creating class": "创建班级出错",
  "Error customizing": "自定义出错",
  "Error deleting": "删除出错",
  "Error exporting calendar": "导出日历出错",
  "Error generating link": "生成链接出错",
  "Error generating plan": "生成教案出错",
  "Error generating suggestions": "生成建议出错",
  "Error generating weekly plan": "生成周计划出错",
  "Error loading AI assignments": "加载AI作业出错",
  "Error loading template": "加载模板出错",
  "Error loading templates": "加载模板出错",
  "Error saving template": "保存模板出错",
  "Error sending email": "发送邮件出错",
  "Essay": "作文题",
  "Essay answers are graded manually": "作文题需人工批改",
  "Everything published successfully!": "全部发布成功！",
  "Ex: Chapter 1 - Vocabulary": "例：第一章 - 词汇",
  "Ex: English": "例：英语",
  "Ex: Greetings and Introductions": "例：问候与介绍",
  "Ex: Prep next week for Unit 3 History (Civil War), matching state curriculum standards": "例：为下周历史第三单元（内战）备课，符合州课程标准",
  "Ex: Unit 1": "例：第一单元",
  "Expiration (days)": "有效期（天）",
  "Expires:": "到期：",
  "Failed to delete": "删除失败",
  "Failed to generate assignment": "生成作业失败",
  "Failed to generate content. Please try again.": "生成内容失败，请重试。",
  "Failed to load data": "加载数据失败",
  "Failed to parse PDF": "解析PDF失败",
  "Failed to publish": "发布失败",
  "Failed to save": "保存失败",
  "Failed to start agent": "启动智能体失败",
  "Failed to upload file": "上传文件失败",
  "False": "错误",
  "File uploaded": "文件已上传",
  "Fill Blank": "填空题",
  "First and last name required": "需要填写姓和名",
  "Friday Quiz": "周五测验",
  "From": "从",
  "Full weekly plan generated! Review each day.": "完整周计划已生成！请检查每一天。",
  "Generate": "生成",
  "Generate Assignment": "生成作业",
  "Generate Assignment with AI": "用AI生成作业",
  "Generate Content": "生成内容",
  "Generate Full Week": "生成整周计划",
  "Generate Plan": "生成教案",
  "Generate Plan with AI": "用AI生成教案",
  "Generate a structured weekly lesson plan with objectives, daily activities, and materials.": "生成包含目标、每日活动和材料的结构化周教案。",
  "Generate a weekly plan with AI and save it as a template": "用AI生成周计划并保存为模板",
  "Generate complete lesson plans": "生成完整教案",
  "Generate content and use the \"Save Content\" button to save it here": "生成内容后，使用\"保存内容\"按钮将其保存在这里",
  "Generate materials based on National Standards, instantly.": "即刻生成符合国家课程标准的教学材料。",
  "Generate practice worksheets": "生成练习卷",
  "Generate with AI": "用AI生成",
  "Generated Content": "生成的内容",
  "Generated Questions": "生成的题目",
  "Generated content will appear here": "生成的内容将显示在这里",
  "Generated with AI Assistant": "由AI助手生成",
  "Generating content...": "正在生成内容...",
  "Generating link...": "正在生成链接...",
  "Generating week...": "正在生成周计划...",
  "Generating...": "生成中...",
  "Generation failed.": "生成失败。",
  "Generation failed. Please try again.": "生成失败，请重试。",
  "Generation timed out": "生成超时",
  "Generation took too long. Please try again.": "生成时间过长，请重试。",
  "Geography": "地理",
  "Get detailed topic summaries": "获取详细的主题摘要",
  "Go to SM Aprendizaje": "前往 SM Aprendizaje",
  "Grade": "年级",
  "Grade Level": "年级",
  "Grade Level *": "年级 *",
  "Grade Report": "成绩报告",
  "Grade Scale": "评分标准",
  "Gradebook": "成绩册",
  "Grades": "成绩",
  "Hard": "困难",
  "Health": "健康",
  "Hi! I'm your AI assistant.": "您好！我是您的AI助手。",
  "High": "高",
  "History": "历史",
  "Hook/Intro": "导入/引入",
  "How do I teach fractions?": "如何教分数？",
  "How to capture attention...": "如何吸引学生注意力...",
  "How to close the lesson...": "如何结束这节课...",
  "I can help you with lesson planning, teaching strategies, and questions about standards.": "我可以帮助您进行备课、教学策略以及课程标准相关问题。",
  "Ideas for reading activities": "阅读活动创意",
  "Instructions for students...": "给学生的说明...",
  "Instructions for this question (optional)...": "本题说明（可选）...",
  "Instructions:": "说明：",
  "Integration with other subjects": "跨学科整合",
  "Item": "项目",
  "Kindergarten": "幼儿园",
  "Language": "语言",
  "Learning Goal": "学习目标",
  "Learning Objective/s": "学习目标",
  "Lesson Date Range": "课程日期范围",
  "Lesson Plan": "教案",
  "Lesson Templates": "教案模板",
  "Lesson Topic": "课程主题",
  "Lessons": "课程",
  "Light": "浅色",
  "Light mode": "浅色模式",
  "Link copied": "链接已复制",
  "Link copied to clipboard": "链接已复制到剪贴板",
  "Link copied!": "链接已复制！",
  "List of materials...": "材料清单...",
  "Loading templates...": "正在加载模板...",
  "Low": "低",
  "Manage Grade Categories": "管理成绩类别",
  "Manage your classes and students": "管理您的班级和学生",
  "Manual Assignments": "手动作业",
  "Match": "配对",
  "Match:": "配对：",
  "Matching": "配对题",
  "Materials Needed": "所需材料",
  "Math": "数学",
  "Mathematics": "数学",
  "Medium": "中等",
  "Multiple Choice": "选择题",
  "Music": "音乐",
  "My Prep Batches": "我的备课批次",
  "My Templates": "我的模板",
  "Name (English)": "名称（英文）",
  "Name (Spanish)": "名称（西班牙文）",
  "Name is required": "名称为必填项",
  "New Lesson": "新课程",
  "New Weekly Prep": "新的每周备课",
  "New chat": "新对话",
  "No assignments": "暂无作业",
  "No assignments created": "尚未创建作业",
  "No categories. Create one to get started.": "暂无类别。创建一个以开始。",
  "No classes today": "今天没有课程",
  "No classes yet": "暂无班级",
  "No content to save": "没有可保存的内容",
  "No email generated": "未生成邮件",
  "No pending assignments": "没有待处理的作业",
  "No prep batches yet": "暂无备课批次",
  "No questions found in the PDF": "PDF中未找到题目",
  "No questions to print": "没有可打印的题目",
  "No quiz generated": "未生成测验",
  "No risk alerts at this time": "目前没有风险提醒",
  "No saved plans yet": "暂无已保存的教案",
  "No saved templates": "没有已保存的模板",
  "No students": "暂无学生",
  "No students in this class": "此班级中没有学生",
  "No students yet": "暂无学生",
  "No suggestions to save": "没有可保存的建议",
  "Number of Questions": "题目数量",
  "Number of questions": "题目数量",
  "Open Portal": "打开门户",
  "Option": "选项",
  "Optional: add specific details...": "可选：添加具体细节...",
  "Or adapt for your specific topic:": "或针对您的具体主题进行调整：",
  "Or create a new prep batch above": "或在上方创建新的备课批次",
  "Or customize for new topic:": "或为新主题自定义：",
  "Original topic:": "原始主题：",
  "Other": "其他",
  "Overdue": "已逾期",
  "Parent Email": "家长邮件",
  "Parent Portal": "家长门户",
  "Period": "节次",
  "Physical Education": "体育",
  "Plan Title": "教案标题",
  "Plan Type": "教案类型",
  "Plan created": "教案已创建",
  "Plan deleted": "教案已删除",
  "Plan duplicated": "教案已复制",
  "Plan generated! Review and edit as needed.": "教案已生成！请根据需要检查和编辑。",
  "Plan saved!": "教案已保存！",
  "Plan updated": "教案已更新",
  "Play to Learn": "玩中学",
  "Please add an objective or topic first to generate suggestions": "请先添加目标或主题以生成建议",
  "Please add an objective or topic first to generate the weekly plan": "请先添加目标或主题以生成周计划",
  "Please allow pop-ups to print": "请允许弹出窗口以打印",
  "Please enter a new topic": "请输入新主题",
  "Please fill in all fields": "请填写所有字段",
  "Please fill in all required fields": "请填写所有必填字段",
  "Please respond in English.": "Please respond in Chinese (Simplified).",
  "Prep Agent": "备课智能体",
  "Prep agent started": "备课智能体已启动",
  "Prep failed": "备课失败",
  "Presentations": "演示文稿",
  "Pricing": "价格",
  "Print": "打印",
  "Print / PDF": "打印 / PDF",
  "Print / Save PDF": "打印 / 保存PDF",
  "Published": "已发布",
  "Question Types": "题型",
  "Quick Actions": "快捷操作",
  "Quiz/Assessment": "测验/测评",
  "Quiz/Test": "测验/考试",
  "Ready for review": "待审阅",
  "Regenerate": "重新生成",
  "Report Cards": "成绩单",
  "Save": "保存",
  "Save & Get Student Link": "保存并获取学生链接",
  "Save Changes": "保存更改",
  "Save Content": "保存内容",
  "Save Template": "保存模板",
  "Save as Template": "保存为模板",
  "Save this plan to reuse with different topics": "保存此教案以便用于其他主题",
  "Saved": "已保存",
  "Saved Lesson Plans": "已保存的教案",
  "Saved Content": "已保存的内容",
  "ESL Support": "ESL 支持",
  "Rubric adapted for English learners (WIDA + PR standards)": "为英语学习者改编的评分标准（WIDA + PR 标准）",
  "Generate ESL-level material for English learners (WIDA + PR standards)": "为英语学习者生成 ESL 级别的材料（WIDA + PR 标准）",
  "Saved on": "保存于",
  "Schedule will appear in your Command Center": "课程表将显示在您的指挥中心",
  "Science": "科学",
  "Select Tool": "选择工具",
  "Select a category": "选择类别",
  "Select a class": "选择班级",
  "Select a class to view its students": "选择班级以查看其学生",
  "Select a prep batch to view details": "选择备课批次以查看详情",
  "Select class": "选择班级",
  "Select...": "选择...",
  "Semester": "学期",
  "Send Email": "发送邮件",
  "Send via Email": "通过邮件发送",
  "Sending...": "发送中...",
  "Share this link with the student's parents. The portal is read-only.": "将此链接分享给学生家长。该门户为只读。",
  "Short Answer": "简答题",
  "Skill...": "技能...",
  "Slides": "幻灯片",
  "Social Studies": "社会研究",
  "Spanish": "西班牙语",
  "Specify other activity...": "指定其他活动...",
  "Specify other material...": "指定其他材料...",
  "Standards": "课程标准",
  "Standards Framework": "标准框架",
  "Start": "开始",
  "Start Prep Agent": "启动备课智能体",
  "Starter": "入门",
  "Starter Templates": "入门模板",
  "Story title": "故事标题",
  "Student": "学生",
  "Student PDF": "学生PDF",
  "Student Progress": "学生进度",
  "Student added": "学生已添加",
  "Student deleted": "学生已删除",
  "Student updated": "学生已更新",
  "Students at Risk": "需关注的学生",
  "Sub Packet": "代课材料包",
  "Subject": "科目",
  "Subject *": "科目 *",
  "Suggest activities": "建议活动",
  "Suggestions applied to notes": "建议已应用到备注",
  "Tags (comma separated)": "标签（逗号分隔）",
  "Take": "开始作答",
  "Taxonomy Levels (Webb 2005)": "分类层级（Webb 2005）",
  "Teacher": "教师",
  "Teacher Name": "教师姓名",
  "Teacher name": "教师姓名",
  "Technology": "技术",
  "Template deleted": "模板已删除",
  "Template name *": "模板名称 *",
  "Template saved!": "模板已保存！",
  "Templates": "模板",
  "This will delete the class and all its students.": "这将删除该班级及其所有学生。",
  "To": "至",
  "To Grade": "待批改",
  "Today's Schedule": "今日课程表",
  "Tools": "工具",
  "Topic": "主题",
  "Topic *": "主题 *",
  "Topic Summary": "主题摘要",
  "Topic:": "主题：",
  "Total Weight": "总权重",
  "Tour": "导览",
  "True": "正确",
  "True/False": "判断题",
  "Type your question...": "输入您的问题...",
  "Upcoming Lessons": "即将到来的课程",
  "Update Assignment": "更新作业",
  "Upload File": "上传文件",
  "Upload a test or document": "上传测试或文档",
  "Uploading...": "上传中...",
  "Use proven templates or save your own successful plans": "使用成熟模板或保存您自己的成功教案",
  "Use this template": "使用此模板",
  "View": "查看",
  "View All": "查看全部",
  "View Assignments": "查看作业",
  "View starter templates": "查看入门模板",
  "Week 1": "第1周",
  "Week 1 - From": "第1周 - 从",
  "Week 1 - To": "第1周 - 至",
  "Week 2": "第2周",
  "Week 2 - From": "第2周 - 从",
  "Week 2 - To": "第2周 - 至",
  "Week Starts": "周开始日",
  "Week of": "周",
  "Weekly Prep Agent": "每周备课智能体",
  "Weekly prep is ready!": "每周备课已就绪！",
  "Welcome": "欢迎",
  "What does CCSS.MATH.4.NF say?": "CCSS.MATH.4.NF 的内容是什么？",
  "Will save:": "将保存：",
  "Working on:": "正在处理：",
  "Worksheet": "练习卷",
  "Worksheets": "练习卷",
  "Write the learning objectives...": "写下学习目标...",
  "You need an active subscription": "您需要有效的订阅",
  "You need an active subscription to use the AI assistant": "您需要有效的订阅才能使用AI助手",
  "Your Request": "您的需求",
  "Your digital classroom": "您的数字教室",
  "Your saved lesson plans for easy access": "您保存的教案，方便随时查看",
  "assignments": "项作业",
  "classes scheduled": "节课已安排",
  "days": "天",
  "days of activities": "天的活动",
  "en-US": "zh-CN",
  "graded": "已批改",
  "of total": "占总数",
  "points": "分",
  "questions": "道题",
  "ready": "就绪",
  "students": "名学生",
  "submissions": "份提交",
  "submissions pending": "份待处理提交",
  "used": "已使用",
  "📅 Calendar file downloaded. Open it to add to Google Calendar, Outlook, or Apple Calendar.": "📅 日历文件已下载。打开它即可添加到 Google 日历、Outlook 或 Apple 日历。",
  "📅 Schedule (Optional)": "📅 课程表（可选）",
  "📅 Weekly Plan (2 Weeks)": "📅 周计划（2周）",
  "📗 Week 2": "📗 第2周",
  "📘 Week 1": "📘 第1周",
  "🗣️ Conversational English": "🗣️ 英语会话",
  "🗣️ Conversational English Plan Details": "🗣️ 英语会话教案详情"
};
